import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import api from "@/lib/api";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ArrowLeft, Loader2, User } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const data = useSite();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    api.get(`/public/blog/${slug}`)
      .then((r) => { setPost(r.data); if (r.data?.seoTitle) document.title = r.data.seoTitle; })
      .catch(() => setPost(null));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[var(--c-bg)]">
      <Navbar site={data?.site} />
      <main className="pt-[100px] pb-24">
        {post === undefined ? (
          <div className="grid place-items-center py-32"><Loader2 className="h-6 w-6 animate-spin text-[var(--c-primary)]" /></div>
        ) : post === null ? (
          <div className="text-center py-32">
            <p className="font-heading text-2xl text-[var(--c-primary)]">পোস্ট পাওয়া যায়নি</p>
            <Link to="/blog" className="inline-block mt-4 text-[var(--c-secondary)]">সব পোস্ট দেখুন</Link>
          </div>
        ) : (
          <article className="max-w-3xl mx-auto px-5 sm:px-8">
            <Link to="/blog" className="inline-flex items-center gap-1.5 font-body text-sm text-[var(--c-muted)] hover:text-[var(--c-primary)] mb-6"><ArrowLeft className="h-4 w-4" /> সব পোস্ট</Link>
            <div><span className="font-body text-xs tracking-widest uppercase text-[var(--c-secondary)]">{post.category}</span></div>
            <h1 className="font-heading font-bold text-[var(--c-primary)] mt-3 text-3xl sm:text-4xl lg:text-5xl leading-tight">{post.title}</h1>
            <div className="flex items-center gap-2 mt-5 text-[var(--c-muted)] font-body text-sm">
              <User className="h-4 w-4" /> {post.author}
              {Array.isArray(post.tags) && post.tags.length > 0 && <span className="ml-2">· {post.tags.join(", ")}</span>}
            </div>
            {post.featured_image && (
              <img src={post.featured_image} alt={post.title} className="w-full h-[320px] sm:h-[420px] object-cover rounded-2xl mt-8 border border-[var(--c-border)]" />
            )}
            <div
              className="prose prose-stone max-w-none mt-8 font-body text-[var(--c-text)]/90 text-lg leading-relaxed [&_h2]:font-heading [&_h2]:text-[var(--c-primary)] [&_h2]:text-2xl [&_h2]:mt-8 [&_h3]:font-heading [&_h3]:text-[var(--c-primary)] [&_blockquote]:border-l-4 [&_blockquote]:border-[var(--c-accent)] [&_blockquote]:pl-5 [&_blockquote]:italic [&_blockquote]:text-[var(--c-muted)] [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_a]:text-[var(--c-secondary)] [&_a]:underline [&_p]:mt-4"
              dangerouslySetInnerHTML={{ __html: post.content || "" }}
            />
          </article>
        )}
      </main>
      <Footer site={data?.site} />
    </div>
  );
}
